import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { getGroup, put_Group } from '../../services/Group';
import baseURL from '../../config/api';
import axios from 'axios';
import { formatUSPhone, handleUSPhoneChange } from '../../utils/phoneFormatter';
import { useUSPhoneValidation } from '../../hook/useUSPhoneValidation';
import useGroup from '../../hook/useGroup';
import EmailFormatValidation from '../../components/EmailFormatValidation';
import Cookies from 'js-cookie';
import LocationFields from '../../components/LocationFields';

const EditChurch = () => {
  const token = Cookies.get("token-my-cdir");
  const { isSuperAdmin }: any = useGroup();
  const pathRoot = isSuperAdmin ? "superadmin" : "admin";
  const navigate = useNavigate();
  const { id }: any = useParams();
  const [isImageUploading, setIsImageUploading] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [churchData, setChurchData] = useState<any>({
    id: 0,
    name: "",
    discription: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    country: "",
    state: "",
    city: "",
    street: "",
    street2: "",
    zip: "",
    isActive: "",
    imagePath: "",
    website: ""
  });
  const {
    isValid: isPhoneValid,
    touched: phoneTouched,
    setTouched: setPhoneTouched
  } = useUSPhoneValidation(churchData.phoneNumber);

  useEffect(() => {
    if (id) {
      getGroup(id, token!.toString())
        .then(res => setChurchData({
          id: res.id,
          name: res.name,
          discription: res.discription,
          firstName: res.firstName,
          lastName: res.lastName,
          emailAddress: res.emailAddress,
          phoneNumber: res.phoneNumber,
          country: res.country,
          state: res.state,
          city: res.city,
          street: res.street,
          street2: res.street2,
          zip: res.zip,
          isActive: res.isActive,
          imagePath: res.imagePath,
          website: res?.website,
          tenantId: res?.tenantId
        }))
        .catch(error => console.error(error));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const close = () => navigate(`/${pathRoot}/church`);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!isPhoneValid) return;
    put_Group(churchData, token!.toString())
      .then(() => {
        navigate(`/${pathRoot}/church`);
      })
      .catch(error => console.error(error))
      .finally(() => setIsSubmitting(false));
  }

  const inputFileRef = useRef<HTMLInputElement>(null);
  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsImageUploading(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);

      axios
        .post(`${baseURL}commonFile/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token?.toString()}`
          },
          withCredentials: true,
        })
        .then((response) => {
          setChurchData({ ...churchData, imagePath: response.data });
          setIsImageUploading(false);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      setIsImageUploading(false);
    }
  };

  return (
    <div className="flex-wrap justify-center items-center w-full">
      <form onSubmit={handleSubmit} className="w-full px-5 py-4">
        <div className="my-2 text-center">
          <h4 className="text-xl text-secondary font-semibold">Edit Church</h4>
          <div className="flex max-xm:flex-col justify-between gap-2 my-4">
            <div className="w-full text-sm">
              <label htmlFor="Church" className="w-full text-start block text-secondary text-xs">
                Church or Organization
              </label>
              <input name="Church"
                type="text" required
                className="w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-secondary"
                placeholder="Enter Church or Organization"
                value={churchData.name}
                onChange={(e) => setChurchData({ ...churchData, name: e.target.value })}
              />
            </div>

            <div className="w-full text-sm">
              <label htmlFor="title" className="w-full text-start block text-secondary text-xs">
                Title
              </label>
              <input name="title"
                type="text" required
                className="w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-secondary"
                placeholder="Enter Title"
                value={churchData.discription}
                onChange={(e) => setChurchData({ ...churchData, discription: e.target.value })}
              />
            </div>

            <div className="w-full text-sm">
              <label htmlFor="churchImage" className="w-full text-start block text-secondary text-xs md:ml-2">
                Church Image
              </label>

              {isImageUploading ? (
                <div className="ml-2 mt-2 text-xs text-secondary flex items-center">
                  <svg className="animate-spin mr-2" width="16" height="16">...</svg>
                  Uploading...
                </div>
              ) : !churchData?.imagePath ? (
                <div className="flex items-center ml-2 mt-2">
                  <label
                    className="text-white bg-secondary text-xs cursor-pointer p-2 rounded"
                    onClick={() => {
                      if (inputFileRef.current !== null) {
                        inputFileRef.current.click();
                      }
                    }}
                  >
                    Add Image
                  </label>
                </div>
              ) : (
                <div>
                  <label
                    className="text-white bg-secondary text-xs cursor-pointer p-2 rounded lg:mr-20"
                    onClick={() => setChurchData({ ...churchData, imagePath: "" })}
                  >
                    Delete
                  </label>
                  <img
                    src={`${baseURL}commonFile/Get?name=${churchData.imagePath}`}
                    width={100}
                    height={80}
                    alt="churchImage"
                    className="md:ml-2 -mt-2.5"
                  />
                </div>
              )}
              <input
                type="file"
                accept="image/*"
                name="churchImage"
                ref={inputFileRef}
                onChangeCapture={onFileChangeCapture}
                className="hidden"
              />
            </div>
          </div>

          <div className="flex max-xm:flex-col justify-between gap-2 my-4">
            <div className="w-full text-sm">
              <label htmlFor="firstname" className="w-full text-start block text-secondary text-xs">
                First Name
              </label>
              <input name="firstname"
                type="text" required
                className="w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-secondary"
                placeholder="Enter First Name"
                value={churchData.firstName}
                onChange={(e) => setChurchData({ ...churchData, firstName: e.target.value })}
              />
            </div>

            <div className="w-full text-sm">
              <label htmlFor="lastname" className="w-full text-start block text-secondary text-xs">
                Last Name
              </label>
              <input name="lastname"
                type="text" required
                className="w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-secondary"
                placeholder="Enter Last Name"
                value={churchData.lastName}
                onChange={(e) => setChurchData({ ...churchData, lastName: e.target.value })}
              />
            </div>
          </div>

          <div className="flex max-xm:flex-col justify-between gap-2 my-4">
            <div className="w-full text-sm">
              <label htmlFor="website" className="w-full text-start block text-secondary text-xs">
                Website
              </label>
              <input
                name="website"
                type="text"
                className="w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-secondary"
                placeholder="Enter website"
                value={churchData.website}
                onChange={(e) => setChurchData({ ...churchData, website: e.target.value })}
              />
            </div>

            <div className="w-full text-sm">
              <EmailFormatValidation
                text={churchData.emailAddress}
                setText={(value) =>
                  setChurchData({
                    ...churchData,
                    emailAddress: value
                  })
                }
                className={{
                  parentDiv: "",
                  label: "w-full text-start block text-secondary text-xs",
                  input:
                    "w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-secondary"
                }}
                required
              />
            </div>
          </div>

          <div className="flex max-xm:flex-col justify-between gap-2 my-4">
            <div className="w-full text-sm">
              <label htmlFor="phoneNumber" className="w-full text-start block text-secondary text-xs">
                Phone Number
              </label>
              <input
                type="tel"
                name="phone"
                value={formatUSPhone(churchData.phoneNumber)}
                onChange={(e) => {
                  setPhoneTouched(true);
                  handleUSPhoneChange(e, (digits) =>
                    setChurchData((prev: any) => ({
                      ...prev,
                      phoneNumber: digits,
                    }))
                  );
                }}
                required
                className="w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-secondary"
                placeholder="Enter phone number"
              />

              {!isPhoneValid && phoneTouched && (
                <p className="text-xs text-red-500 mt-1">
                  Please enter a valid 10-digit phone number
                </p>
              )}
            </div>

            <div className="w-full text-sm"></div>
          </div>

          <div className="flex max-xm:flex-col justify-between gap-2 my-4">
            <div className="w-full text-sm">
              <label htmlFor="street" className="w-full text-start block text-secondary text-xs">
                Street
              </label>
              <input name="street"
                type="text" required
                className="w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-secondary"
                placeholder="Enter Street"
                value={churchData.street}
                onChange={(e) => setChurchData({ ...churchData, street: e.target.value })}
              />
            </div>

            <div className="w-full text-sm">
              <label htmlFor="street2" className="w-full text-start block text-secondary text-xs">
                Street 2
              </label>
              <input name="street2"
                type="text"
                className="w-full border bg-[#f0f1f2] border-gray-300 px-2 py-2 rounded outline-secondary"
                placeholder="Enter Street 2"
                value={churchData.street2}
                onChange={(e) => setChurchData({ ...churchData, street2: e.target.value })}
              />
            </div>
          </div>
        </div>

        <div className="grid xm:grid-cols-2 gap-6">
          <LocationFields
            userData={churchData}
            setUserData={setChurchData}
          />
        </div>

        <div className="flex max-xm:flex-col gap-4 !mt-4 mb-8">
          <button
            type="button"
            className="px-6 py-2 min-w-[150px] w-full rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
            onClick={close}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-6 py-2 min-w-[150px] w-full rounded text-white text-sm font-semibold border-none outline-none bg-secondary hover:bg-custom-blue"
          >
            {isSubmitting ?
              <>
                <svg xmlns="http://www.w3.org/2000/svg" width="18px" fill="#fff" className="mr-2 inline animate-spin"
                  viewBox="0 0 26.349 26.35">
                  <circle cx="13.792" cy="3.082" r="3.082" data-original="#000000" />
                  <circle cx="13.792" cy="24.501" r="1.849" data-original="#000000" />
                  <circle cx="6.219" cy="6.218" r="2.774" data-original="#000000" />
                  <circle cx="21.365" cy="21.363" r="1.541" data-original="#000000" />
                  <circle cx="3.082" cy="13.792" r="2.465" data-original="#000000" />
                  <circle cx="24.501" cy="13.791" r="1.232" data-original="#000000" />
                  <path
                    d="M4.694 19.84a2.155 2.155 0 0 0 0 3.05 2.155 2.155 0 0 0 3.05 0 2.155 2.155 0 0 0 0-3.05 2.146 2.146 0 0 0-3.05 0z"
                    data-original="#000000" />
                  <circle cx="21.364" cy="6.218" r=".924" data-original="#000000" />
                </svg>
                Processing...
              </>
              :
              "Save"
            }
          </button>
        </div>
      </form>
    </div>
  )
}

export default EditChurch